/* eslint-disable */
export default function () {
  return <h1>Página 404</h1>;
}
